import React, {useRef} from 'react';
import StoryboardCellComponent from '@/views/storyboard/cell/StoryboardCellComponent';
import {Chart, ChartQuery, ChartSettings} from '@/entities/chart';

interface NotDraggableStoryboardCellComponentProps {
    id: number;
    chartQuery: ChartQuery;
    chart: ChartSettings;
    writeAccess: boolean;
    deleteChart: (index: number) => void;
    onNewChartSave: (chartData: Chart, toIndex?: number) => void;
    modifyChart: (chartData: Chart) => void;
    moveChart: (dragIndex: number, hoverIndex: number) => void;
    onChartMove: () => void;
    index: number;
    hasError?: boolean;
    isRearrangeMode: boolean;
}

const NotDraggableStoryboardCellComponent: React.FC<NotDraggableStoryboardCellComponentProps> = (props) => {
    const ref = useRef<HTMLDivElement>(null!);
    return (
        <StoryboardCellComponent
            isDragging={false}
            innerRef={ref}
            {...props}  
        />
    );
};

export default NotDraggableStoryboardCellComponent;
